var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndex2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#index2_svg__clip0_247_28405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8a8 8 0 018-8h16v16a8 8 0 01-8 8H0V8z",
    fill: "#000",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.919 17v-1.25l3.612-4.52c.14-.182.235-.351.285-.508.034-.148.051-.288.051-.419 0-.347-.108-.65-.324-.907-.224-.259-.541-.392-.952-.4-.364 0-.666.116-.907.349-.25.232-.398.56-.445.984H8.92c.034-.77.292-1.407.774-1.911.487-.49 1.086-.74 1.797-.749.795.008 1.44.262 1.936.762.503.495.76 1.123.768 1.885 0 .61-.186 1.151-.559 1.625l-2.977 3.732h3.536V17H8.919z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "index2_svg__clip0_247_28405"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgIndex2;